import { Button, Typography } from '@mui/material';
import { Check } from '@ankr.com/ui';
import { t, tHTML } from '@ankr.com/common';
import { useEffect } from 'react';

import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';

import { UpgradeToPremiumPlanDialog } from '../../../UpgradeToPremiumPlanDialog';
import { usePremiumContentStyles } from './usePremiumContentStyles';

export const PremiumContent = () => {
  const { classes } = usePremiumContentStyles();

  const { handleSignIn } = useSSOAuth();
  const { isEnterprise, isPremium } = useAccountStatus();

  useEffect(() => {
    const element = document.getElementById('sign-in');

    if (element) {
      element.onclick = handleSignIn;
    }
  }, [handleSignIn]);

  const {
    isOpened: isPromoDialogOpened,
    onClose: onPromoDialogClose,
    onOpen: onPromoDialogOpen,
  } = useDialog();

  if (isPremium || isEnterprise) return null;

  return (
    <>
      <div className={classes.root}>
        <div className={classes.content}>
          <Typography variant="subtitle2" className={classes.title}>
            {t('chains.upgrade-premium.title')}
          </Typography>

          <>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {tHTML('chains.upgrade-premium.item-1')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-2')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-3')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-4')}
            </Typography>
          </>
          <Button
            fullWidth
            size="small"
            className={classes.button}
            onClick={onPromoDialogOpen}
          >
            {t('chains.upgrade-premium.button')}
          </Button>
        </div>
      </div>
      <UpgradeToPremiumPlanDialog
        isPromoDialogOpened={isPromoDialogOpened}
        onPromoDialogClose={onPromoDialogClose}
      />
    </>
  );
};
